import React, { useEffect } from "react";
import images from "components/images";
import get from "lodash/get";
import styled from "styled-components";
import { connect } from "react-redux";
import Card from "@material-ui/core/Card";
import { GET_DISCORD_INFO } from "store/actions/index";

const Discord = ({ getData, presenceCount, playersOnline, code }) => {
  useEffect(() => {
    getData();
  }, [getData]);

  return (
    <StyledLink
      href={`https://discord.gg/${code}`}
      target="_blank"
      rel="noopener noreferrer"
    >
      <Container>
        <img
          src={images["DiscordLogo"]}
          width="128"
          height="128"
          alt={"discord"}
        />
        <Wrapper>
          <StyledCard>
            <b>Online: {playersOnline}</b>
          </StyledCard>
          <StyledCard>
            <b>Members: {presenceCount}</b>
          </StyledCard>
        </Wrapper>
      </Container>
    </StyledLink>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    getData: () => dispatch({ type: GET_DISCORD_INFO }),
  };
};

const mapStateToProps = (state) => {
  return {
    presenceCount: get(
      state,
      "rootReducer.discord.info.approximate_member_count"
    ),
    playersOnline: get(
      state,
      "rootReducer.discord.info.approximate_presence_count"
    ),
    code: get(state, "rootReducer.discord.info.code"),
  };
};

const Container = styled.div`
  display: flex;
  > div {
    display: flex;
    flex-direction: column;
  }
`;

const StyledLink = styled.a`
  text-decoration: none;
  color: black;
`;

const StyledCard = styled(Card)`
  padding: 5px;
  margin: 2px;
`;

const Wrapper = styled.div`
  justify-content: space-between;
  align-self: center;
`;

export default connect(mapStateToProps, mapDispatchToProps)(Discord);
